import gql from 'graphql-tag';

export const Good360SetStatusMutation = gql`
	mutation Good360SetStatusMutation($id: ID!, $newStatus: Status360!) {
		good360SetStatus(id: $id, newStatus: $newStatus) {
			id
			status
		}
	}
`;